import styled from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//helpers
import { screen } from '@/helpers/screen';

//components
import { HeroFx } from '@/components/HeroFx';

export const CareersWrapper = styled.section`
  position: relative;
  isolation: isolate;
  font: 400 16px / 1.6 ${getToken('font-family-default')};
  color: #fff;
  background: radial-gradient(
      ellipse 912px 1036px at 50% 100%,
      #004a4a 0%,
      #003434 23%,
      #001b1b 46%,
      #000 85%,
      #000 100%
    ),
    #000;

  /* mobile: the photo sits on top, the text below it */
  &::before {
    content: '';
    display: block;
    height: 260px;
    background: url(/images/about/careers.webp) center / cover no-repeat;
  }

  ${screen.lg} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: stretch;
    min-height: clamp(440px, 40vw, 560px);
    background: radial-gradient(
        ellipse 912px 1036px at 75% 0,
        #004a4a 0%,
        #003434 23%,
        #001b1b 46%,
        #000 85%,
        #000 100%
      ),
      #000;

    &::before {
      grid-column: 1;
      grid-row: 1;
      height: auto;
    }
  }
`;

export const CareersEffect = styled(HeroFx)`
  position: absolute;
  inset: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  pointer-events: none;
  mix-blend-mode: screen;
  opacity: 0.38;
  mask-image: linear-gradient(to top, #000 62%, transparent 100%);

  ${screen.lg} {
    grid-column: 2;
    grid-row: 1;
    mask-image: linear-gradient(to bottom, #000 62%, transparent 100%);
  }
`;

export const CareersContent = styled.div`
  padding: 40px 20px 56px;

  ${screen.lg} {
    grid-column: 2;
    grid-row: 1;
    align-self: center;
    padding: 64px clamp(32px, 5vw, 72px);
  }
`;

export const Title = styled.h2`
  margin: 0;
  font: 700 clamp(32px, 4vw, 44px) / 1.2 ${getToken('font-family-title')};
  letter-spacing: -0.015em;
`;

export const Copy = styled.p`
  max-width: 832px;
  margin: 14px 0 0;
  font: 600 clamp(17px, 1.5vw, 19px) / 1.65 ${getToken('font-family-title')};
  text-wrap: balance;
`;

export const CareersButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 52px;
  padding: 0 28px;
  border-radius: 6px;
  margin-top: 36px;
  background: linear-gradient(90deg, #00d6d6, #14d64d);
  color: #06210f;
  font: 700 16px/1 ${getToken('font-family-title')};
  text-decoration: none;
  white-space: nowrap;
  transition: filter 0.15s, transform 0.15s;

  &:hover {
    filter: brightness(1.07);
    transform: translateY(-1px);
  }
`;
